import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const PlatformConfiguratorContainer = () => import(/* webpackChunkName: "platform-configurator" */ './containers/PlatformConfiguratorContainer');

const PlatformConfiguratorRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        exact
        load={PlatformConfiguratorContainer}
        path={`${match.url}`}
      />
      <Redirect to="/" />
    </Switch>
  </LoginRequiredContainer>
);

PlatformConfiguratorRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default PlatformConfiguratorRoutes;
